import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectKeys',
})
export class ObjectKeysPipe implements PipeTransform {
  transform(value: Record<string,any>): (keyof typeof value)[] {
    return Object.keys(value);
  }
}
